import React, { useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { colors } from '../../Themes'
import { Text } from '..'
import { PrimaryButton } from '../Button/Button'
import CloseIcon from '@material-ui/icons/Close'
import { 
  IconButton,
  Tooltip,
} from '@material-ui/core'
import { discount, CopyIconWhite } from '../../Themes/Images'
import { useHistory } from 'react-router-dom'
import useStyles from './DiscoundCard.styles'

function DiscoundCard({ code }) {
  const classes = useStyles()
  const history=useHistory()
  const [isCopied, setIsCopied] = useState(false)

  return (
    <div className={classes.Contrainer}>
      <img src={discount} alt='asdasd'/>
      <Text size="h5" color={colors.white} style={{ marginInline: 18 }} >20% Discount for Giga plan, here is your promo code:</Text>
      <div className={classes.codeContainer} >
        <Text size='h5' weight='medium'  color={colors.white} style={{ marginRight: 26 }}>{code}</Text>
        <CopyToClipboard onCopy={() => {
          setIsCopied(true)
          setTimeout(() => { setIsCopied(false) }, 3000)
        }} text={code}>
          <IconButton classes={{ root: classes.iconButton }} >
            <Tooltip key='discoundCode' open={isCopied} title="Code copied to clipboard" placement="top" arrow>
              <CopyIconWhite className={classes.copyIcon} />
            </Tooltip>
          </IconButton>
        </CopyToClipboard>
      </div>
      <PrimaryButton
        className={classes.button}
        onClick={()=>history.push('/upgradeplan')}
      >
          Go to payment
      </PrimaryButton>
      <IconButton
        disableFocusRipple
        centerRipple={true}
        disableRipple={true}
        style={{ backgroundColor: 'transparent' }}
        classes={{ root: classes.iconButtonClose }}
        // onClick={onClose}
      >
        <CloseIcon classes={{ root: classes.closeIcon }} />
      </IconButton>
    </div>
  )
}

export default DiscoundCard
